
















































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  RailpassRequest,
  postRailpassRequest,
  getRailpassRequests
} from "../services/azure/azureservice";

@Component
export default class Index extends Vue {
  @Prop() private msg!: string;

  @Prop() private railRequest: RailpassRequest = {
    Insz: "",
    Email: "",
    Firstname: "",
    Lastname: "",
    Address: ""
  };

  @Prop() private completedRequests: RailpassRequest[] | null = null;

  submitForm() {
    postRailpassRequest(this.railRequest);
  }

  async retrieveRequests() {
    const result = await getRailpassRequests();
    this.$props["completedRequests"] = result;
  }
}
